var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPro2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 65,
    viewBox: "0 0 120 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_1134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.057 32.7278C118.057 49.7533 104.25 63.5603 87.2243 63.5603C70.1988 63.5603 56.4014 49.7533 56.4014 32.7278C56.4014 15.7024 70.1988 1.90491 87.2243 1.90491",
    stroke: "#D91966",
    strokeWidth: 2.38051,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.963257 50.3921L15.4463 35.9091",
    stroke: "#3F3F3F",
    strokeWidth: 1.42831,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5893 50.3921L28.0723 35.9091",
    stroke: "#3F3F3F",
    strokeWidth: 1.42831,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2153 50.3921L40.6983 35.9091",
    stroke: "#3F3F3F",
    strokeWidth: 1.42831,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8413 50.3921L53.3339 35.9091",
    stroke: "#3F3F3F",
    strokeWidth: 1.42831,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4674 50.3921L65.96 35.9091",
    stroke: "#3F3F3F",
    strokeWidth: 1.42831,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1045 50.3921L78.5876 35.9091",
    stroke: "#3F3F3F",
    strokeWidth: 1.42831,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7306 50.3921L91.2136 35.9091",
    stroke: "#3F3F3F",
    strokeWidth: 1.42831,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_1134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 119.978,
    height: 64.75,
    fill: "white",
    transform: "translate(0.0110474)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPro2);
export default __webpack_public_path__ + "static/media/pro2.fc383c78d4daa3208d10b5680bbc1bb7.svg";
export { ForwardRef as ReactComponent };